module.exports = __webpack_public_path__ + "Sailec-Regular.a05444e891dc3b8ef7bc.otf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Regular/Sailec-Regular.otf
// module id = ../../../../../src/assets/fonts/Sailec-Regular/Sailec-Regular.otf
// module chunks = styles